import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.DescargaZEDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Folio DescargaZE", cell: x => ({ data: x.Folio }) },
    { title: "Fecha", cell: x => ({ data: kea.formatDate(x.Fecha) }) },
    { title: "Proveedor", cell: x => ({ data: x.NombreProveedor }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChofer }) },
    { title: "Placas", cell: x => ({ data: x.PlacasVehiculo }) },
];


export interface BotonesDeps {
    onEdit: (item: Entity) => void;
    onDelete: (item: Entity) => void;
}

function botones(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Modificar descarga de zona extendida",
            style: "primary",
            iconClass: fa("pencil", "fw"),
            onClick: deps.onEdit,
            disabled: x => !permisos.CargaZE.Editar
        },
        {
            tooltip: "Eliminar descarga de zona extendida",
            style: "danger",
            iconClass: fa("trash-o", "fw"),
            onClick: deps.onDelete,
            disabled: x => !permisos.CargaZE.Eliminar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "350px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps, permisos), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/list/columns.tsx